import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter {
    isDeliveryFieldCompletedValue: boolean;
}

type HandlerType = CustomHandler<Parameter>;

export const CenSpcDeliveryFieldCompleted: HandlerType = props => {
    props.dispatch({
        type: "Pages/OnePageCheckout/CenSpcDeliveryFieldCompleted",
        isDeliveryFieldCompletedValue: props.parameter.isDeliveryFieldCompletedValue,
    });
};

export const chain = [CenSpcDeliveryFieldCompleted];

const cenSpcDeliveryFieldCompleted = createHandlerChainRunner(chain, "CenSpcDeliveryFieldCompleted");
export default cenSpcDeliveryFieldCompleted;
